import {
    moodboardAddLookButtonDone,
    moodboardAddLookButtonStyleRollBack
} from "../common/components/addLookToMoodboardButton";

const $ = require('jquery');
import {Router} from '../common/router';

const modal = $('.moodboards-container');
const moodboard = document.querySelector('.moodboards-container');
const moodboardSelectList = moodboard.querySelector('.moodboard-select-list');
const carouselDetails = document.querySelector('.carousel-details') || document.querySelector('.details');
const searchContainer = moodboard.querySelector('.search-moodboards');
const searchMessage = moodboard.querySelector('.moodboard-search-message');
const lang = document.documentElement.lang;
const moreResults = moodboard.querySelector('#moodboard-more-results');
let total;
let current;
let query;
let surroundQueryNumber;
const tts = require('../common/tts');
let spinner = document.createElement('p');
let ajaxSearchQuery;
spinner.classList.add('loader');
spinner.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';

$(document).ready(function () {
    $('#viewer').on('hidden.bs.modal', function () {
        resetMoodboard();
    });
    document.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            resetMoodboard();
        }
    });
    Array.from(document.querySelectorAll('#carousel .viewer-previous, #carousel .viewer-next')).map(btn => {
        btn.addEventListener('click', function () {
            if (!btn.classList.contains('disabled')) {
                resetMoodboard()
            }
        })
    });

    document.querySelector('.moodboard-create').addEventListener('click', function () {
        document.querySelector('.moodboard-create-form').classList.add('form-active');
    });

    document.querySelector('.moodboard-create-form').addEventListener('submit', function (e) {
        e.preventDefault();
        createAndAdd(this, current);
    });

    moreResults.addEventListener('click', seeMore);
    searchContainer.querySelector('.search-input').addEventListener('keyup', function (e) {
        if (e.key === 'Enter') {
            const searchInput = searchContainer.querySelector('.search-input');
            moreResults.classList.add('no-more-results');
            if (searchInput.value.length === 0) {
                moodboardSelectList.dataset.loading = 'loading';
                initSeeMore();
            }
            searchMoodboards(e);
        }
    });
    searchContainer.querySelector('.search-moodboards .input-group-prepend').addEventListener('click', function () {
        const searchInput = searchContainer.querySelector('.search-input');
        moreResults.classList.add('no-more-results');
        if (searchInput.value.length === 0) {
            moodboardSelectList.dataset.loading = 'loading';
            initSeeMore();
        }
        searchMoodboards(searchInput);
    });
    searchContainer.querySelector('.search-delete').addEventListener('click', () => {
        const searchInput = searchContainer.querySelector('.search-input');
        if (searchInput.value.length > 0) {
            searchInput.value = '';
            moodboardSelectList.dataset.loading = 'loading';
            moreResults.classList.add('no-more-results');
            searchMoodboards(searchInput);
            initSeeMore();
        }
    });
});

const initNeedSubscription = () => {
    moodboardSelectList.style.display = 'none';
    const needAuthentificationBlock = document.querySelector('.need-authentification');
    needAuthentificationBlock.style.display = 'block';
    moodboardSelectList.style.display = 'none';
    searchContainer.style.display = 'none';
    carouselDetails.classList.add('unactive');
    moodboard.classList.add('active');
    modal.find('.moodboard-item').remove();
    const socials = $('.carousel-details-footer .row-no-gutters').clone(true);
    modal.find('.moodboard-social').append(socials);
    const socialBar = moodboard.querySelector('.moodboard-social');
    socialBar.classList.add('stick-bottom');
    addUrlEditParam();
};

const addUrlEditParam = () => {
    const link = document.querySelector('.need-authentification a');
    link.addEventListener('click', (e) => {
        e.preventDefault()
        const href = link.href;
        if (href) {
            window.open(href + "#edit", '_blank');
        }
    })
}

const initAddToMoodboardModal = (currentItem) => {
    showMoodboardContainer(currentItem);
    const selectedLook = document.querySelector('.carousel-item-link img');
    const socials = $('.carousel-details-footer .row-no-gutters').clone(true);
    const landscapeHeight = document.querySelector('.viewer-header').style.display = 'none' ? 5 : 0;
    modal.find('.moodboard-social').append(socials);
    setMoodboardsContainerHeight(selectedLook, landscapeHeight);
    getMoodboardsInit();
    initCollapseMoodboardButton();
    scrollToMoodobardOnMobile();
};

const initAddToMoodboard = (currentItem) => {
    showMoodboardContainer(currentItem);
    const selectedLook = document.querySelector('.left-column.photo img');
    const socials = $('.share-look').clone(true);
    const toggleButtonHeight = document.querySelector('.collapse-moodboards-btn').offsetHeight;
    modal.find('.moodboard-social').append(socials);
    setMoodboardsContainerHeight(selectedLook, toggleButtonHeight);
    initCollapseMoodboardButton();
    getMoodboardsInit();
    scrollToMoodobardOnMobile();
};

const initCollapseMoodboardButton = () => {
    moodboard.querySelector('.collapse-moodboards-btn').classList.add('active');
    moodboard.querySelector('.collapse-moodboards-btn').addEventListener('click', function () {
        this.classList.remove('active');
        moodboardAddLookButtonStyleRollBack();

        const addToMoodboardButton = document.querySelector('.add-to-moodboard-button');
        addToMoodboardButton.classList.remove('add-to-moodboard-button-added');

        resetMoodboard();
    });
}

const initDataToMoodboards = (data, currentItem) => {
    const prototype = moodboard.querySelector('.moodboard-prototype');

    for (let i = 0; i < data.moodboards.length; i++) {
        let item = data.moodboards[i];
        let itemBlock = prototype.cloneNode(true);
        itemBlock.className = 'moodboard-item multi-photo-card';
        itemBlock.dataset.slug = item.slug;
        itemBlock.dataset.type = currentItem['type'] === 'street' ? 'streetstyle' : 'media';
        itemBlock.dataset.lookSlug = currentItem['slug'];
        itemBlock
            .querySelector('.photo-card-img')
            .setAttribute('alt', item.name);
        let imgsGrid = Array.from(itemBlock.querySelectorAll('.moodboard-item-img'));

        for (let j = 0; j < item.items.length; j++) {
            if (item.items[j].files.length > 0) {
                imgsGrid[j].src = item.items[j].files[0].path_cover;
                imgsGrid[j].alt = `${item.name}-${j}`;
                imgsGrid[j].classList.add('loading');
                imgsGrid[j].addEventListener('load', (e) => {
                    e.target.classList.remove('loading');
                })
            }
        }

        const count = item.total_items ?? 0;
        const totalItems = Translator.transChoice('moodboard.count.items', count, {count});
        itemBlock.querySelector('.photo-card-sticker-text .title').innerHTML = item.name;
        itemBlock.querySelector('.photo-card-sticker-text .total-items').innerHTML = totalItems;
        moodboard.querySelector('.moodboard-select-list').appendChild(itemBlock);
        moodboard.querySelector('.moodboard-select-list').appendChild(moreResults);

        itemBlock.addEventListener('click', () => {
            addLookToMoodboard(itemBlock);
        })
    }
}

const createAndAdd = (form, current) => {
    if (form.classList.contains('submissions')) {
        return false;
    }
    let buttonText = form.querySelector('button').innerHTML;
    let name = form.querySelector('.moodboard-create-form-input').value;
    form.classList.add('submission');
    form.querySelector('button').innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
    $.ajax({
        method: 'PUT',
        global: false,
        url: Router.generate('moodboards_create_and_add.' + lang, {
            'type': current['type'] === 'street' ? 'streetstyle' : 'media',
            'slug': current['slug']
        }),
        data: name,
        statusCode: {
            403: function () {
                window.location.href = Router.generate('auth_index.' + lang)
            }
        }
    }).done(function (message) {
        document.querySelector('.moodboard-create .multi-photo-card').classList.remove('card-active');
        moodboard.querySelector('.moodboard-create-message').classList.add('alert-success');
        moodboard.querySelector('.moodboard-create-message').innerText = message;
        moodboardSelectList.dataset.totalCount = `${parseInt(moodboardSelectList.dataset.totalCount) + 1}`;
    }).fail(function (jqXHR) {
        if (jqXHR.status !== 403) {
            moodboard.querySelector('.moodboard-create-message').classList.add('alert-danger');
            moodboard.querySelector('.moodboard-create-message').innerText = jqXHR.responseText;
        }
    }).always(function () {
        form.classList.remove('submission');
        form.querySelector('button').innerHTML = buttonText;
        form.querySelector('.moodboard-create-form-input').value = '';
        moodboard.querySelector('.moodboard-create-message').style.display = 'initial';
    })
}

const searchMoodboards = (e) => {
    if (document.querySelector('.loader')) {
        ajaxSearchQuery.abort();
        watchLoading();
    }
    const moodboardListItems = Array.from(moodboard.querySelectorAll('.moodboard-item'));
    const search = e.value !== undefined ? e.value.toLowerCase() : e.target.value.toLowerCase();

    moodboardListItems.map(item => {
        item.remove();
    });
    spinner.style.visibility = 'visible';
    searchMessage.classList.remove('alert-no-results', 'alert-error');
    moodboard.querySelector('.moodboard-create-form').classList.remove('form-active');
    moodboard.querySelector('.moodboard-create .multi-photo-card').classList.add('card-active');
    moodboard.querySelector('.moodboard-select-message').style.display = 'none';
    moodboard.querySelector('.moodboard-create-message').style.display = 'none';
    moodboard.querySelector('.moodboard-select-list').insertAdjacentElement('beforeend', spinner);
    ajaxSearchQuery = $.ajax({
        method: 'GET',
        global: false,
        url: Router.generate('moodboards_ajax_list.en', {
            search
        })
    }).done(function (data) {
        moodboardSelectList.dataset.loading = '';
        if (data.moodboards.length === 0) {
            searchMessage.classList.add('alert-no-results');
            searchMessage.innerText = Translator.transChoice('viewer.modal_moodboard.search.no_results');
        } else {
            initDataToMoodboards(data, current);
        }
    }).fail(function () {
        searchMessage.classList.add('alert-error');
        searchMessage.innerText = Translator.transChoice('viewer.modal_moodboard.search.error');
    }).always(function () {
        moodboard.querySelector('.loader').remove();
    })
}

const addLookToMoodboard = (currentMoodboard) => {
    if (modal.find('.moodboard-select').hasClass('loading')) {
        return false;
    }

    modal.find('.moodboard-select').addClass('loading');

    currentMoodboard.append(spinner);

    const dataType = currentMoodboard.getAttribute('data-type'),
        dataSlug = currentMoodboard.getAttribute('data-slug'),
        dataLookSlug = currentMoodboard.getAttribute('data-look-slug');

    $.ajax({
        method: 'PUT',
        global: false,
        url: Router.generate('moodboards_add_look.' + lang, {
            'slug': dataSlug,
            'type': dataType,
            'lookSlug': dataLookSlug
        }),
        statusCode: {
            403: function () {
                window.location.href = Router.generate('auth_index.' + lang)
            }
        }
    }).done(function (data) {
        currentMoodboard.remove();

        moodboardAddLookButtonDone();

        modal.find('.moodboard-select-message')
            .addClass('alert-success')
            .text(data);

        if (dataType === 'media') {
            tts.media(dataLookSlug, 'moodboard_add');
        } else {
            tts.streetstyle(dataLookSlug, 'moodboard_add');
        }
    }).fail(function (jqXHR) {
        if (jqXHR.status !== 403) {
            modal.find('.moodboard-select-message')
                .text(xhr.responseText)
                .addClass('alert-danger');
        }
    }).always(function () {
        modal.find('.moodboard-select').removeClass('loading');
        modal.find('.moodboard-select-message').show();
        moodboard.querySelector('.moodboard-select-message').scrollIntoView(true);
    });
}

const resetMoodboard = () => {
    $('.moodboard-select-list .moodboard-item').remove();
    $('.moodboard-create-message, .moodboard-select-message')
        .empty()
        .removeClass('alert-success alert-danger')
        .hide();
    $(modal).find('.loader').remove();
    $('.moodboard-create-form').removeClass('form-active');
    $('.moodboard-create .multi-photo-card').addClass('card-active');
    carouselDetails.classList.remove('unactive');
    $('.moodboard-social').empty();
    modal.removeClass('active');
    moodboard.querySelector('.search-moodboards input').value = '';
    searchMessage.classList.remove('alert-no-results', 'alert-error');
    moreResults.classList.remove('no-more-results');
    moodboard.querySelector('.moodboard-see-more-message').classList.remove('alert-error');
    moodboardSelectList.dataset.currentPage = '1';
}

const initSeeMore = () => {
    if (moreResults.classList.contains('disabled')) {
        return false;
    }
    total = parseInt(moodboardSelectList.dataset.totalCount);
    query = JSON.parse(moreResults.dataset.query);
    moodboardSelectList.dataset.query = JSON.stringify(query);
    surroundQueryNumber = query.from + query.size;
    if (surroundQueryNumber !== surroundQueryNumber % total) {
        moreResults.querySelector('.more-results-number').innerText = query.size - surroundQueryNumber % total;
    } else {
        moreResults.querySelector('.more-results-number').innerText = query.size;
    }
    if (query.size >= total) {
        moreResults.classList.add('no-more-results');
    }
    watchLoading();
}

const seeMore = () => {
    if (moreResults.classList.contains('disabled')) {
        return false;
    }
    const path = moreResults.dataset.path;
    moreResults.querySelector('p').style.visibility = 'hidden';
    moreResults.querySelector('i').className = 'fal fa-spinner fa-spin fa-2x';
    moreResults.classList.add('disabled');
    let esc = encodeURIComponent;
    let params = Object.keys(query)
        .map(k => esc(k) + '=' + (query[k] ? esc(query[k]) : ''))
        .join('&');
    fetch(path + '?' + params, {
        method: 'GET',
        headers: {'X-Requested-With': 'XMLHttpRequest'},
    }).then(function (response) {
        if (response.status === 403) {
            return;
        }
        response.json().then(function (data) {
            moodboardSelectList.dataset.currentPage = `${query.from > 0 ? Math.round((query.from / query.size) + 1) : 1}`;
            moodboardSelectList.dataset.query = JSON.stringify(query);
            moreResults.querySelector('p').style.visibility = '';
            moreResults.querySelector('i').className = 'fal fa-long-arrow-down fa-2x';
            moreResults.classList.remove('disabled');
            query.from += query.size;
            surroundQueryNumber = query.from + query.size;
            if (surroundQueryNumber !== surroundQueryNumber % total) {
                moreResults.querySelector('.more-results-number').innerText = query.size - surroundQueryNumber % total;
            }
            if (query.from >= total || data.length === 0) {
                moreResults.classList.add('no-more-results');
            }
            initDataToMoodboards(data, current);
        });
    }).catch(function (error) {
        const seeMoreMessage = moodboard.querySelector('.moodboard-see-more-message');
        seeMoreMessage.classList.add('.alert-error');
        seeMoreMessage.innerText = Translator.transChoice('viewer.modal_moodboard.see_more.error');
        moodboard.querySelector('.moodboard-see-more-message').scrollIntoView(true);
        moreResults.querySelector('p').style.visibility = '';
        moreResults.querySelector('i').className = 'fal fa-long-arrow-down fa-2x';
        moreResults.classList.remove('disabled');
    });
}

const watchLoading = () => {
    const observer = new MutationObserver((mutations) => {
        mutations.map(mutation => {
            if (mutation.oldValue === 'loading' && query.size < total) {
                moreResults.classList.remove('no-more-results');
            }
        });
    });
    observer.observe(moodboardSelectList, {
        attributes: true,
        attributeOldValue: true
    });
}

const showMoodboardContainer = (currentItem) => {
    current = currentItem;
    spinner.style.visibility = 'visible';
    moodboard.style.visibility = 'hidden';
    moodboard.insertBefore(spinner, moodboard.childNodes[0]);
    carouselDetails.classList.add('unactive');
    moodboard.classList.add('active');
    modal.find('.moodboard-item').remove();
}

const getMoodboardsInit = () => {
    $.ajax({
        method: 'GET',
        global: false,
        url: Router.generate('moodboards_ajax_list.en'),
    }).then(function (data) {
        moodboardSelectList.dataset.totalCount = data.count;
        if (data.moodboards.length === 0) {
            moreResults.classList.add('no-more-results');
        }
        initSeeMore();
        initDataToMoodboards(data, current);
        moodboard.style.visibility = 'visible';
        moodboard.querySelector('.loader').remove();
    }).catch(function () {
        window.location.href = Router.generate('auth_index.' + lang)
    });
}

/**
 * searchHeight as + 5 for extra margin that
 * cannot be retrieved from DOM
 *
 * @param {HTMLElement} selectedLook
 * @param {...int} heights - divs offsetHeight
 */
const setMoodboardsContainerHeight = (selectedLook, ...heights) => {
    const title = moodboard.querySelector('.moodboard-select-title').offsetHeight;
    const socialsHeight = moodboard.querySelector('.moodboard-social').offsetHeight;
    const line = moodboard.querySelector('.line-separator').offsetHeight;
    const searchHeight = searchContainer.offsetHeight + 5;
    let heightSum = title + socialsHeight + line + searchHeight;
    heights.map(height => heightSum += height);
    moodboard.querySelector('.moodboard-select-list').style.height = `${selectedLook.height - heightSum}px`;
}

const scrollToMoodobardOnMobile = () => {
    if (!window.matchMedia('(max-width: 992px)')) {
        return;
    }

    const moodboardSelect = document.querySelector('.moodboard-select');

    setTimeout(() => {
        moodboardSelect.scrollIntoView({ behavior: "smooth" });
    }, 0);
}

export {initNeedSubscription, initAddToMoodboardModal, initAddToMoodboard};
